<app-nav-bar/>
<ng-template #error>
  <div class="container" *ngIf="!promotion">
    <div class="container" >
      <section class="section error-404 min-vh-100 d-flex flex-column align-items-center justify-content-center">
        <h1 class="" style="font-size: 100px">404</h1>
        <h2 class="text-center">Al parecer la página que intentabas acceder ya no existe.</h2>
        <a class="btn  buttonAGlobal mx-2 " routerLink="/promociones">Regresar a promociones</a>
      </section>
    </div>
  </div>
</ng-template>



<div class="container " *ngIf="promotion else error "  >
  <div class="py-2 ">
    <div class="container text-center mt-5" >

      <a routerLink="/promociones">
        <img src="assets/img/medilinkLogo.svg"  width="300px" alt="">

      </a>

<!--      <h3>{{ this.namePromocion }}</h3>-->
      <nav aria-label="breadcrumb ">

        <ol class="breadcrumb text-center" style="font-size: .9rem">
          <li class="breadcrumb-item"><a routerLink="/promociones/">Promociones</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{ this.namePromocion }}</li>
        </ol>
      </nav>
    </div>
    <div class="row g-5 ">
      <div *ngIf="!linkPago" class="col-md-5 col-lg-5 order-md-last">
        <h4 class="d-flex justify-content-between align-items-center mb-3">
          <span class="text-primary">Tu compra</span>
        </h4>
        <ul class="list-group mb-3">
          <li class="list-group-item d-flex justify-content-between lh-sm">
            <div>
              <h6 class="my-0">{{ this.namePromocion }}</h6>
              <small class="text-body-secondary">{{convertirPrimeraLetraMayuscula(promotion.tipo_desc)  }}</small>
              <div class="w-100 mt-2 mx-0 mb-2">
                <img class="w-100" src="{{ imgMongo}}" alt="">
              </div>
            </div>
<!--            <span class="text-body-secondary">${{ promotion.valor_desc }}</span>-->
          </li>
          <li class="list-group-item d-flex justify-content-between lh-sm">
            <div >
            <h6 class="my-0 bold">Contenido del paquete</h6>
              <small class="text-body-secondary" [innerHTML]="serviciosMongo"></small>
            </div>

          </li>
          <li class="list-group-item d-flex justify-content-between lh-sm">
            <div >
            <h6 class="my-0 bold">Terminos y condiciones</h6>
              <small class="text-body-secondary  "><span class="text-danger">{{disclaimerMongo}}*</span></small>
            </div>
          </li>
          <li class="list-group-item d-flex justify-content-between">
            <span>Total (USD)</span>
            <strong>          <span style="font-size: 1.1rem" class="fw-bolder">${{ promotion.valor_desc }}</span>
            </strong>
          </li>
        </ul>
        <div class="w-100 align-baseline" *ngIf="dataUser">
          <button (click)="onclickCreate()" class="buttonAGlobal btn btn-primary w-100" [disabled]="isLoading">
            <span class="text" *ngIf="!isLoading">
            FINALIZAR COMPRA  <i class="bi bi-cart-check-fill"></i>
            </span>
            <div *ngIf="isLoading" class="spinner-border text-light " role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </button>
        </div>



      </div>
      <div *ngIf="!linkPago" class="col-md-7 col-lg-7 ">
        <h4 class="mb-3 text-primary">Identificación</h4>
        <div class="col-12">
<!--          <label for="identificacion" class="form-label text-secondary">Identificación</label>-->
          <div class=" input-group mb-3">
            <input (blur)="searchId($event)" type="text" class="inputGlobal form-control " [value]="identificacion"
                   id="identificacion" placeholder="Ingresa tu cédula/pasaporte" required>
            <button class="btn btn-primary rounded-end-circle " type="button" id="button-addon2"><i
              class="bi bi-search"></i></button>

            <div class="invalidInput" *ngIf="!exists">
              El paciente no se encuentra registrado en MediLink
            </div>
            <div class="invalidInput" *ngIf="validCedula">
              Tu numero de cedula no es correcto.
            </div>
            <div class="invalidInput" *ngIf="manyRequest">
              Demasiadas solicitudes, por favor intenta mas tarde.
            </div>
          </div>
          <p style="font-size: 13px" class="text-secondary">Al continuar estás aceptando nuestras <a routerLink="/politica-privacidad">politicas
            de uso y tratamiento de información personal</a></p>
          <div class="formRegister mb-5" *ngIf="!exists">
            <app-form-register-user [personaId]="personaId"/>
          </div>

        </div>

        <div class="" *ngIf="dataUser">
            <h4 class="d-flex justify-content-between align-items-center mb-3">
              <span class="text-primary">Datos del Paciente</span>
            </h4>
            <ul class="list-group mb-3">
              <li class="list-group-item d-flex justify-content-between lh-sm">
                <div>
                  <h6 class="my-0">Nombre: </h6>
                  <small class="text-body-secondary">{{ names }}</small>
                  <h6 class="my-0">Email: </h6>
                  <small class="text-body-secondary">{{ email }}</small>
                </div>
              </li>
            </ul>
            <div class="mb-5">
              <form [formGroup]="createOrden" (ngSubmit)="onclickCreate()">
                <h4 class="mb-3 text-primary">Sucursal</h4>
                <select formControlName="codSucursal" name="codSucursal" id="inputSucursal"
                        class="form-control inputGlobal"
                        [ngClass]="{'invalid': isCodSucursalInvalid()}">
                  <option value="" disabled selected>Seleccionar Sucursal</option>
                  <option *ngFor="let sucursal of sucursales"
                          [value]="sucursal.codSucursal">{{ sucursal.sucursal_nombre_comercial }}
                  </option>
                </select>
                <div *ngIf="isCodSucursalInvalid()" class="invalidInput">
                  Por favor seleccione una sucursal.
                </div>
              </form>


          </div>

        </div>

      </div>
      <div @fadeInUp class=" w-100 " *ngIf="linkPago">
        <div class="container text-center mx-auto my-3 fs-2 text-success">
          <i class="bi bi-check-circle"></i>
        </div>
        <div class="card-body grid gap-3">
          <h5 class="card-title text-center p-2">Promoción Adquirida con Éxito</h5>
          <p class="card-text p-2">Nos complace informarle que su promoción ha sido generada exitosamente. Para completar el proceso, le invitamos a proceder con el pago a través del siguiente enlace. </p>
          <div class="container text-center mx-auto">
          <a target="_blank" class="fs-6 p-2 mt-2 buttonAGlobalPay btn btn-primary w-50" *ngIf="linkPago" href="{{this.linkPago}}">Pagar
            <i class="bi bi-credit-card"></i></a>
            <br>
            <a  class="fs-6 buttonAGlobal btn btn-primary w-50 p-2 mt-2"  routerLink="/promociones">Ver más promociones <i class="bi bi-basket3-fill"></i></a>

          </div>
        </div>
        <!--<ul class="list-group list-group-flush">
          <li class="list-group-item">An item</li>
          <li class="list-group-item">A second item</li>
          <li class="list-group-item">A third item</li>
        </ul>
        <div class="card-body">
          <a href="#" class="card-link">Card link</a>
          <a href="#" class="card-link">Another link</a>
        </div>-->
      </div>

    </div>

  </div>









